module.exports = "img/delete.cfc6d24.png";